import { Link } from 'react-router-dom'
import { FaArrowRight } from 'react-icons/fa6'
import AnimatedSection from '../common/AnimatedSection'

/**
 * Shared split-panel CTA used on Contact, Services, and similar pages.
 */
function SplitPageCta({
  sectionClass,
  panelClass,
  title,
  description,
  primaryCta,
  secondaryCta,
  imageSrc,
  useAnchor = false,
}) {
  const PrimaryTag = useAnchor ? 'a' : Link
  const SecondaryTag = useAnchor ? 'a' : Link
  const primaryProps = useAnchor ? { href: primaryCta.to } : { to: primaryCta.to }
  const secondaryProps = useAnchor ? { href: secondaryCta.to } : { to: secondaryCta.to }

  return (
    <AnimatedSection className={sectionClass}>
      <div className="container corp-container">
        <div className={panelClass}>
          <span className={`${sectionClass}__dots`} aria-hidden="true" />
          <div className="row g-4 align-items-center">
            <div className="col-lg-7">
              <div className={`${sectionClass}__copy`}>
                <h2>{title}</h2>
                <p>{description}</p>
                <div className={`${sectionClass}__actions`}>
                  <PrimaryTag
                    className={`${sectionClass}__btn ${sectionClass}__btn--primary`}
                    {...primaryProps}
                  >
                    {primaryCta.label}
                    <FaArrowRight aria-hidden="true" />
                  </PrimaryTag>
                  <SecondaryTag
                    className={`${sectionClass}__btn ${sectionClass}__btn--secondary`}
                    {...secondaryProps}
                  >
                    {secondaryCta.label}
                    <FaArrowRight aria-hidden="true" />
                  </SecondaryTag>
                </div>
              </div>
            </div>
            {imageSrc ? (
              <div className="col-lg-5 d-none d-lg-block">
                <div className={`${sectionClass}__visual`}>
                  <img src={imageSrc} alt="" loading="lazy" aria-hidden="true" />
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </AnimatedSection>
  )
}

export default SplitPageCta
